import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, formatApiError } from "@/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Car } from "lucide-react";
import GoogleSignInButton from "@/components/GoogleSignInButton";

export default function LoginPage() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await login(email, password); toast.success("Xoş gəlmisiniz!"); nav("/dashboard"); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail) || "Xəta"); }
    finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-14 fade-in">
      <div className="flex justify-center mb-6"><div className="h-12 w-12 rounded-2xl bg-slate-900 flex items-center justify-center"><Car className="h-6 w-6 text-white" /></div></div>
      <h1 className="text-3xl font-extrabold tracking-tighter text-center text-slate-900">Xoş gəldiniz</h1>
      <p className="text-center text-slate-500 mt-1 mb-8">Hesabınıza daxil olun</p>
      <form onSubmit={submit} className="bg-white rounded-2xl border border-slate-200 p-6 space-y-4">
        <GoogleSignInButton label="Google ilə giriş" />
        <div className="relative flex items-center py-1">
          <div className="flex-grow border-t border-slate-200"></div>
          <span className="mx-3 text-xs uppercase tracking-widest text-slate-400 font-bold">və ya</span>
          <div className="flex-grow border-t border-slate-200"></div>
        </div>
        <div><Label className="text-xs uppercase tracking-widest font-bold text-slate-500">Email</Label><Input data-testid="login-email" type="email" value={email} onChange={e => setEmail(e.target.value)} required className="mt-1.5 rounded-xl h-12" /></div>
        <div><Label className="text-xs uppercase tracking-widest font-bold text-slate-500">Şifrə</Label><Input data-testid="login-password" type="password" value={password} onChange={e => setPassword(e.target.value)} required className="mt-1.5 rounded-xl h-12" /></div>
        <Button data-testid="login-submit" type="submit" disabled={loading} className="w-full rounded-full h-12 bg-blue-600 hover:bg-blue-700 font-semibold">{loading ? "Daxil olur..." : "Giriş"}</Button>
        <p className="text-center text-sm text-slate-600">Hesabınız yoxdur? <Link to="/register" className="text-blue-600 font-semibold">Qeydiyyat</Link></p>
      </form>
    </div>
  );
}
